import React from 'react';

const QuestionInstructionDetail = ({
  instruction = ""
}) => {
  return (
    <div className="px-3 py-1 text-sm font-normal flex items-center mb-1">
      <p className="leading-relaxed whitespace-pre-line"><b>{instruction}</b></p>
    </div>
  );
};

export default QuestionInstructionDetail;
